// extracted by mini-css-extract-plugin
module.exports = {"cin":"ServCard_cin__2Uwgv","sub":"ServCard_sub__1qJ_1","head":"ServCard_head__1q1oX","card":"ServCard_card__1g7bN"};